import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    font-family: ${theme.v3.font.family.brand};
    flex-direction: column;
    gap: ${theme.v3.spacing.xxs};
    padding: ${theme.v3.spacing.nano};
  `}
`;

export const ModalHeader = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.nano};
    padding-top: 28px;
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.large};
    font-weight: ${theme.v3.font.weights.medium};
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[30]};
    margin: 0;
    text-align: center;
  `}
`;

export const WrapperButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.v3.spacing.xxxs};
    justify-content: center;
    margin-top: ${theme.v3.spacing.nano};
  `}
`;
